import {
	boostDestroy,
	boostList,
	boostShow,
	boostUpdate,
} from '@/services/tv/boosts.service'

export default {
	namespaced: true,
	state: {
		// SERVICE BOOSTS
		boostList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		boost: {},

		// STATUS SERVICE BOOSTS
		boostListStatus: 'pending',
		boostSaveStatus: 'init',
		boostDeleteStatus: 'init',
	},
	getters: {
		// SERVICE BOOSTS
		getBoostList(state) {
			return state.boostList
		},
		getBoost(state) {
			return state.boost
		},

		// STATUS SERVICE BOOSTS
		getBoostListStatus(state) {
			return state.boostListStatus
		},
		getBoostSaveStatus(state) {
			return state.boostSaveStatus
		},
		getBoostDeleteStatus(state) {
			return state.boostDeleteStatus
		},
	},
	mutations: {
		// SERVICE BOOSTS
		BOOST_LIST(state, value) {
			state.boostList = value
		},
		SET_BOOST(state, value) {
			state.boost = value
		},

		// STATUS SERVICE BOOSTS
		BOOST_LIST_STATUS(state, value) {
			state.boostListStatus = value
		},
		BOOST_SAVE_STATUS(state, value) {
			state.boostSaveStatus = value
		},
		BOOST_DELETE_STATUS(state, value) {
			state.boostDeleteStatus = value
		},
	},
	actions: {
		// Service Boosts
		async fetchBoostList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('BOOST_LIST_STATUS', 'pending')
			commit('BOOST_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await boostList(params)
				commit('BOOST_LIST_STATUS', 'init')
				commit('BOOST_LIST', data)
				return data
			} catch (error) {
				commit('BOOST_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchBoostByID({ commit }, params) {
			commit('BOOST_LIST_STATUS', 'pending')
			try {
				const { data } = await boostShow(params)
				commit('BOOST_LIST_STATUS', 'init')
				commit('SET_BOOST', data.data)
				return data
			} catch (error) {
				commit('BOOST_LIST_STATUS', 'init')
				return error
			}
		},
		async updateBoost({ commit }, params) {
			commit('BOOST_SAVE_STATUS', 'pending')
			try {
				const { data } = await boostUpdate(params)
				commit('BOOST_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOOST_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteBoostByID({ commit }, params) {
			commit('BOOST_DELETE_STATUS', 'pending')
			try {
				const { data } = await boostDestroy(params)
				commit('BOOST_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BOOST_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
